import { render, staticRenderFns } from "./modelYC.vue?vue&type=template&id=3a057555"
import script from "./modelYC.vue?vue&type=script&lang=js"
export * from "./modelYC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports